import { render } from "./autotag.vue?vue&type=template&id=ba01df3a"
import script from "./autotag.vue?vue&type=script&lang=js"
export * from "./autotag.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__